import { createStoreHook } from '@/utils/createStoreHook';

import { IActiveSessionStoreContextValue, ActiveSessionStore } from '@/store/ActiveSessionStore';

export const useActiveSessionStore = createStoreHook<IActiveSessionStoreContextValue>(
  ActiveSessionStore,
  'ActiveSessionStore',
);
